import { api } from './api';

export interface AISuggestion {
  description?: string;
  specs?: Record<string, string>;
  suggestedPrice?: number;
  margin?: number;
}

export async function generateDescription(
  productName: string,
  category: string,
): Promise<string> {
  try {
    const result = await api.ai.generateDescription(productName, category);
    return result.description;
  } catch {
    return '';
  }
}

export async function generateSpecs(
  productName: string,
  category: string,
): Promise<Record<string, string>> {
  try {
    const result = await api.ai.generateSpecs(productName, category);
    return result.specs;
  } catch {
    return {};
  }
}

export async function suggestPricing(
  cost: number,
  category: string,
): Promise<{ suggestedPrice: number; margin: number }> {
  try {
    return await api.ai.suggestPricing(cost, category);
  } catch {
    return { suggestedPrice: cost * 1.5, margin: 33 };
  }
}

export async function generateAllSuggestions(
  productName: string,
  category: string,
  cost: number,
): Promise<AISuggestion> {
  const [description, specs, pricing] = await Promise.allSettled([
    generateDescription(productName, category),
    generateSpecs(productName, category),
    suggestPricing(cost, category),
  ]);

  return {
    description: description.status === 'fulfilled' ? description.value : undefined,
    specs: specs.status === 'fulfilled' ? specs.value : undefined,
    suggestedPrice: pricing.status === 'fulfilled' ? pricing.value.suggestedPrice : undefined,
    margin: pricing.status === 'fulfilled' ? pricing.value.margin : undefined,
  };
}
